import React, { useState, useEffect, useCallback } from 'react';
import { Button, Table, Modal } from 'react-bootstrap';
import axios from 'axios';
import { useCookies } from 'react-cookie';
import { getUserRoles } from '../../utils/SecurityUtils';
import './TeamUsersTab.css';
import TeamUserDetailForm from '../TeamUserDetailForm/TeamUserDetailForm';

const TeamUsersTab = () => {
    const [users, setUsers] = useState([]);
    const [showAddModal, setShowAddModal] = useState(false);
    const [showEditModal, setShowEditModal] = useState(false);
    const [selectedUser, setSelectedUser] = useState(null);
    const [cookies] = useCookies(['AuthorizationToken']);
    const [isAdmin, setIsAdmin] = useState(false);

    const fetchUsers = useCallback(async () => {
        try {
            const response = await axios.get('https://api.foveaai.com/evaluate/web/team/users', {
                headers: { Authorization: cookies.AuthorizationToken }
            });
            if (response.status === 200) {
                setUsers(response.data.users);
            } else {
                // no-op: inner form will display errors on submit flows
            }
        } catch (error) {
            // no-op: display could be added here if needed
        }
    }, [cookies.AuthorizationToken]);

    useEffect(() => {
        const checkUserRole = async () => {
            const roles = await getUserRoles();
            const hasAdminOrPrimaryRole = roles.some(role => role.name === 'admin' || role.name === 'primary');
            setIsAdmin(hasAdminOrPrimaryRole);
        };

        checkUserRole();
        if (isAdmin) {
            fetchUsers();
        }
    }, [cookies.AuthorizationToken, isAdmin, fetchUsers]);

    if (!isAdmin) {
        return (
            <div className="register-form-container">
                <p>You do not have the necessary permissions to view or edit the team users.</p>
            </div>
        );
    }

    return (
        <div className="team-users-tab">
            <Button variant="primary" onClick={() => setShowAddModal(true)}>
                Add Team User
            </Button>

            <Table bordered hover>
                <thead>
                    <tr>
                        <th>Status</th>
                        <th>First Name</th>
                        <th>Last Name</th>
                        <th>User Name</th>
                        <th>Roles</th>
                    </tr>
                </thead>
                <tbody>
                    {users.map(user => (
                        <tr key={user.user_id} onClick={() => {
                            setSelectedUser(user);
                            setShowEditModal(true);
                        }}>
                            <td>
                                <span className={`status-icon ${user.active ? 'active' : 'inactive'}`}></span>
                            </td>
                            <td>{user.first_name}</td>
                            <td>{user.last_name}</td>
                            <td>{user.email}</td>
                            <td>{user.roles && Array.isArray(user.roles) ? user.roles.map(role => role.name).join(', ') : ''}</td>
                        </tr>
                    ))}
                </tbody>
            </Table>

            <Modal show={showAddModal} onHide={() => setShowAddModal(false)} size="lg" centered dialogClassName="job-detail-form-modal-custom">
                <Modal.Body className="job-detail-form-modal-body-custom">
                    <TeamUserDetailForm
                        user_object={null}
                        closeModal={() => setShowAddModal(false)}
                        triggerReload={fetchUsers}
                    />
                </Modal.Body>
            </Modal>

            <Modal show={showEditModal} onHide={() => setShowEditModal(false)} size="lg" centered dialogClassName="job-detail-form-modal-custom">
                <Modal.Body className="job-detail-form-modal-body-custom">
                    <TeamUserDetailForm
                        user_object={selectedUser}
                        closeModal={() => setShowEditModal(false)}
                        triggerReload={fetchUsers}
                    />
                </Modal.Body>
            </Modal>
        </div>
    );
};

export default TeamUsersTab;